import React from 'react'
import AuthLayout from 'src/layout/AuthLayout'
import DefaultLayout from 'src/layout/DefaultLayout'
import Login from 'src/views/pages/login/Login'

const Dashboard = React.lazy(() => import('../views/dashboard/Dashboard'))
const Tokens = React.lazy(() => import('../views/base/tokens/Tokens'))
const ManageToken = React.lazy(() => import('../components/tokenManagement/ManageToken'))

const routes = [
  {
    path: '/',
    element: <DefaultLayout />,
    children: [
      { path: '/dashboard', element: <Dashboard />, exact: true },
      { path: '/tokens', element: <Tokens />, exact: true },
      { path: '/tokens/add', element: <ManageToken mode="create" />, exact: true },
      { path: '/tokens/edit/:id', element: <ManageToken mode="update" />, exact: true },
    ],
  },
  {
    path: 'auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
    ],
  },
]

export default routes
